/* FENN: hexágono de cor na página do produto (13/09/2026). O tema continua desenhando um seletor de
 * cor comum (botões de texto, acessível, ligado ao formulário nativo de variante/comprar); este
 * script só decora cada botão: lê o nome da cor (aria-label do input) e insere um hexágono próprio
 * (".fenn-hex"), pintado com --c, usando a MESMA tabela de palavras-chave do carrossel de fotos dos
 * cartões (snippets/fenn-carrossel-fluido.liquid). NÃO reaproveita o
 * ".variant-option__button-label__pill" do tema: apesar do nome, esse elemento é o FUNDO animado que
 * desliza pra marcar a opção selecionada (position:absolute, width:100% do botão inteiro,
 * settings.variant-picker-styles.liquid) - não é um espaço reservado pra ícone/swatch. Também mostra,
 * ao lado da legenda "Cor", o nome da cor selecionada (igual ao layout offline), atualizado ao trocar.
 * Idempotente e religado por MutationObserver (o tema re-renderiza o seletor ao trocar de
 * variante/produto).
 *
 * Fenn (19/09/2026, pedido do Leonardo): o mesmo hexágono passou a decorar também o fieldset "Cor"
 * dentro do modal de confirmação da cestinha (#quick-add-modal-content) - ver ligarModal/
 * observarModal no fim do arquivo. Esse fieldset ali é só uma CÓPIA do HTML da página real (buscado
 * por fetch em assets/quick-add.js), então travarAltura (que depende do <main> da página DE VERDADE)
 * não faz sentido nesse contexto - por isso ligarGrupo aceita um segundo parâmetro (opts) pra pular
 * só essa parte quando chamado a partir do modal. Trocar a foto ao trocar de cor CONTINUA acontecendo
 * no modal (pedido do Leonardo), só que mirando o carrossel de DENTRO do próprio modal (opts.
 * areaCarrossel), nunca o da página de produto real por trás dele. */
(function () {
  // Fenn (19/09/2026): por RADICAL, não pela palavra inteira - com 'preto'/'branco' as cores
  // cadastradas no feminino ("Preta", "Branca", ex.: Camiseta Preta Ringer BSW) não batiam com nada e
  // os hexágonos saíam todos cinza (#cccccc). Mesma tabela, na mesma ordem, em
  // snippets/variant-main-picker.liquid (hexágono do produto de uma cor só): mudou uma, muda a outra.
  var TABELA = [
    ['pret', '#151515'], ['black', '#151515'], ['branc', '#f2f2f2'], ['white', '#f2f2f2'],
    ['cinza', '#8a8a8a'], ['gray', '#8a8a8a'], ['grey', '#8a8a8a'], ['azul', '#3b5b8c'], ['blue', '#3b5b8c'],
    ['vermelh', '#b5432e'], ['red', '#b5432e'], ['verde', '#4f5a3a'], ['green', '#4f5a3a'],
    ['marrom', '#5a4032'], ['brown', '#5a4032'], ['bege', '#d9c7a7'], ['beige', '#d9c7a7'],
    ['rox', '#6b4b8f'], ['lil', '#6b4b8f'], ['purple', '#6b4b8f'], ['amarel', '#e3c04b'], ['yellow', '#e3c04b'],
    ['rosa', '#e29bb0'], ['pink', '#e29bb0'], ['laranja', '#e07b39'], ['orange', '#e07b39']
  ];
  var NOMES_OPCAO_COR = ['cor', 'cores', 'color', 'colour', 'colors'];

  function hexPara(nome) {
    var chave = (nome || '').toLowerCase();
    for (var i = 0; i < TABELA.length; i++) {
      if (chave.indexOf(TABELA[i][0]) > -1) return TABELA[i][1];
    }
    return '#cccccc';
  }

  function ligarGrupo(fieldset, opts) {
    opts = opts || {};
    var legend = fieldset.querySelector('legend');
    if (!legend) return;
    // Já montado nesta legenda? Não faz nada (evita loop: mexer no texto do rótulo dispara o próprio
    // MutationObserver de novo, e escrever o mesmo texto de novo dispararia outra vez, sem parar).
    if (legend.querySelector('.fenn-cor-selecionada')) return;

    var nomeOpcao = (legend.textContent || '').trim().toLowerCase();
    if (NOMES_OPCAO_COR.indexOf(nomeOpcao) === -1) return;

    // Marca só este fieldset (não o de Tamanho, por exemplo) pra CSS pintar o hexágono só aqui.
    fieldset.classList.add('fenn-opcao-cor');

    fieldset.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input || label.querySelector('.fenn-hex')) return;
      var nomeCor = (input.getAttribute('aria-label') || '').replace(/ - .*/, '');
      var hex = document.createElement('span');
      hex.className = 'fenn-hex';
      hex.style.setProperty('--c', hexPara(nomeCor));
      label.appendChild(hex);
    });

    var rotulo = document.createElement('span');
    rotulo.className = 'fenn-cor-selecionada';
    legend.appendChild(rotulo);
    // Fenn (19/09/2026, corrigindo "trocarFotoDaCor chamada 4x num clique só", achado pelo selo de
    // diagnóstico): NÃO prender mais o listener de 'change' no próprio fieldset. O Shopify redesenha
    // (morph) o formulário de variante várias vezes durante uma única sessão do modal (preço,
    // disponibilidade, hidratação) e cada redesenho pode trocar o NÓ do fieldset por um novo - a
    // marcação ".fenn-cor-selecionada" nem sempre sobrevive a essas trocas do mesmo jeito, então o
    // guard acima ("já montado?") ora deixa passar de novo, ora não, e cada passagem que deixa
    // acabava empilhando mais um listener no fieldset (do momento) - vários listeners vivos,
    // disparando todos juntos no clique seguinte. Ver ligarDelegacaoModal() (ligada uma única vez,
    // fora desta função) pro caso do modal: um único listener em document, nunca duplicado, que
    // funciona não importa quantas vezes o fieldset for substituído. A página de produto de
    // verdade (fora do modal, sem opts.areaCarrossel) continua com o listener direto de sempre -
    // lá o fieldset não é redesenhado com essa frequência, isso nunca deu problema.
    if (!opts.areaCarrossel) {
      fieldset.addEventListener('change', function () {
        atualizarRotulo(fieldset, rotulo);
        trocarFotoDaCor(fieldset, opts.areaCarrossel);
      });
    }
    atualizarRotulo(fieldset, rotulo);
    // Sincroniza a foto com a cor já selecionada ao montar (ex.: página aberta via ?variant= vindo de
    // um cartão da grade - ver função ligar() logo abaixo pra entender por que essa chamada sozinha
    // aqui não bastava e teve que ser repetida lá).
    trocarFotoDaCor(fieldset, opts.areaCarrossel);
    if (!opts.semAltura) travarAltura(fieldset);
  }

  // Fenn (19/09/2026): único listener de 'change' pro fieldset de Cor DENTRO do modal da cestinha,
  // por delegação em document - nunca duplicado (variável fecha o módulo, guard simples), e
  // funciona não importa quantas vezes o Shopify substitua o nó do fieldset por baixo. Sempre
  // procura o rótulo/carrossel ATUAIS na hora do evento, nunca guarda referência antiga.
  var delegacaoModalLigada = false;
  function ligarDelegacaoModal() {
    if (delegacaoModalLigada) return;
    delegacaoModalLigada = true;
    document.addEventListener('change', function (e) {
      var fieldset = e.target.closest && e.target.closest('#quick-add-modal-content fieldset.fenn-opcao-cor');
      if (!fieldset) return;
      var rotulo = fieldset.querySelector('.fenn-cor-selecionada');
      if (rotulo) atualizarRotulo(fieldset, rotulo);
      trocarFotoDaCor(fieldset, document.getElementById('quick-add-modal-content'));
    });
  }

  // Fenn (16/09/2026, "trocar sem mudar a altura da página"): mede a altura JÁ CORRETA deste fieldset
  // (legenda "Cor <nome>" + fileira de hexágonos, prontos) e trava esse número numa variável CSS no
  // <main> (não no próprio fieldset) - ver fenn-produto.css, que lê essa variável como `height` +
  // `overflow: hidden`. A variável fica no <main> (elemento estável, nunca trocado pelo Shopify) e não
  // no fieldset porque o `morph` do Shopify pode SUBSTITUIR o nó do fieldset inteiro por um novo (sem
  // o estilo inline que uma variável posta nele mesmo carregaria) - uma variável CSS herdada de um
  // ancestral estável já vale pro fieldset novo desde o primeiro quadro em que ele existe, sem
  // depender do MutationObserver rodar de novo a tempo. `height` fixo (não `min-height`) porque o
  // problema medido pelo diagnóstico não era só a fileira COLAPSAR (min-height já resolvia isso) - era
  // o HTML nativo temporário do Shopify ficar um pouco MAIS ALTO que o hexágono final por um instante;
  // `min-height` não segura um excesso por cima, só evita encolher demais. `overflow: hidden` corta
  // esse excesso temporário em vez de deixá-lo empurrar "Tamanho" e o botão de comprar.
  function travarAltura(fieldset) {
    var area = document.querySelector("main[data-template='product']");
    if (!area) return;
    // Solta a trava antes de medir: se já tinha um valor travado (ex.: reaproveitado depois de girar
    // o celular), o fieldset já estaria preso NESSE tamanho antigo e a medida só repetiria o mesmo
    // número de sempre, nunca corrigindo pro tamanho novo.
    area.style.removeProperty('--fenn-cor-altura-travada');
    var altura = fieldset.getBoundingClientRect().height;
    if (altura) area.style.setProperty('--fenn-cor-altura-travada', altura + 'px');
  }

  // Troca a foto do carrossel (assets/fenn-carrossel-fluido.js, mesmo motor dos cartões da vitrine)
  // pra acompanhar a cor escolhida no seletor nativo, mantendo a posição da foto - "igual página
  // inicial", como pedido. A ordem dos <label> do fieldset é a mesma ordem das cores no JSON que
  // blocks/_product-media-gallery.liquid manda pro carrossel (as duas vêm de
  // product.options_with_values), por isso o índice do rádio marcado serve direto pro carrossel.
  function trocarFotoDaCor(fieldset, areaCarrossel) {
    var labels = fieldset.querySelectorAll('label');
    var indice = -1;
    labels.forEach(function (label, i) { if (label.querySelector('input:checked')) indice = i; });
    if (indice < 0) return;
    // areaCarrossel vem do modal da cestinha (ligarModal, abaixo) - ali o carrossel é o próprio, não
    // o da página de produto real. Sem areaCarrossel (chamada normal da página de produto), usa o
    // seletor de sempre.
    var carrossel = areaCarrossel
      ? areaCarrossel.querySelector('[data-carrossel]')
      : document.querySelector("main[data-template='product'] .product-information__media [data-carrossel]");
    if (carrossel && typeof carrossel._fennTrocarCor === 'function') carrossel._fennTrocarCor(indice);
  }

  function atualizarRotulo(fieldset, rotulo) {
    var marcado = fieldset.querySelector('input:checked');
    var novoTexto = marcado ? (marcado.getAttribute('aria-label') || '').replace(/ - .*/, '') : '';
    // Só escreve se mudou: setar o mesmo texto de novo ainda dispara o MutationObserver (childList
    // muda mesmo quando o valor é igual), o que manteria o loop girando.
    if (rotulo.textContent !== novoTexto) rotulo.textContent = novoTexto;
  }

  function ligar() {
    document.querySelectorAll("main[data-template='product'] fieldset.variant-option--buttons").forEach(function (fs) { ligarGrupo(fs); });
    // Fenn (14/09/2026): a chamada de trocarFotoDaCor lá dentro de ligarGrupo só executa na PRIMEIRA
    // vez (o "return" cedo no topo de ligarGrupo evita re-decorar o fieldset, mas também impede
    // qualquer código depois dele de rodar de novo) - e nessa primeira vez o carrossel
    // (fenn-carrossel-fluido.js) ainda pode não ter terminado de montar (o <script defer> dele fica
    // MAIS TARDE no HTML, dentro do bloco da galeria, então roda DEPOIS do <script defer> deste
    // arquivo, carregado cedo em layout/theme.liquid - "defer" executa na ordem dos <script>, não na
    // ordem em que os elementos aparecem na página). Por isso repete aqui, TODA VEZ que o
    // MutationObserver disparar (inclusive quando o próprio carrossel terminar de montar fotos e
    // botões, o que também conta como mutação) - sem gate nenhum, porque já é idempotente sozinho
    // (trocarCor() do carrossel não faz nada se a cor pedida já é a atual).
    document.querySelectorAll("main[data-template='product'] fieldset.fenn-opcao-cor").forEach(function (fs) { trocarFotoDaCor(fs); });
  }

  function observar() {
    // Fenn (14/09/2026, corrige "tela pulando" ao trocar de cor): antes o observador vigiava a
    // página INTEIRA (document.documentElement) - qualquer mutação em QUALQUER lugar (WhatsApp
    // flutuante, carrinho, pixels de rastreio, "vistos recentemente" etc.), o dia inteiro, disparava
    // de novo a varredura completa do formulário do produto e uma chamada a trocarFotoDaCor. Medido:
    // um único toque no hexágono de cor disparava esse processamento até 6 vezes, inclusive mais de
    // meio segundo depois, sem nenhuma relação com o clique - trabalho redobrado bem na hora em que a
    // pessoa está tocando a tela, o tipo de coisa que engasga a rolagem/animação num iPhone real. Só
    // interessa mutação DENTRO do formulário do produto (é aí que o tema re-renderiza o seletor de
    // variante e o carrossel monta suas fotos), então o alvo passa a ser só essa área.
    var area = document.querySelector("main[data-template='product']");
    if (!area) return;
    new MutationObserver(ligar).observe(area, { childList: true, subtree: true });
  }

  // Fenn (19/09/2026): mesma decoração (hexágono + nome da cor), mas escopada ao modal da cestinha -
  // sem travarAltura (não é o <main> real da página, é só o modal). A foto AINDA troca ao trocar de
  // cor (pedido do Leonardo: "quando eu mudar a cor tem que alterar a cor da miniatura"), só que sem
  // deixar arrastar/passar pro lado (isso já é o comportamento de somenteCapa em
  // fenn-carrossel-fluido.js) - por isso passa areaCarrossel: modal, pra trocarFotoDaCor procurar o
  // carrossel DENTRO do modal (a cópia própria dele), nunca o da página de produto real por trás.
  // Um observer PRÓPRIO, pequeno (só o conteúdo do modal), pela mesma razão de performance do
  // observar() acima - nunca o documento inteiro.
  function ligarModal() {
    var modal = document.getElementById('quick-add-modal-content');
    if (!modal) return;
    ligarDelegacaoModal();
    modal.querySelectorAll('fieldset.variant-option--buttons').forEach(function (fs) {
      ligarGrupo(fs, { semAltura: true, areaCarrossel: modal });
    });
  }

  function observarModal() {
    var modal = document.getElementById('quick-add-modal-content');
    if (!modal) return;
    new MutationObserver(ligarModal).observe(modal, { childList: true, subtree: true });
  }

  // Fenn (19/09/2026): o carrossel avisa (fenn-carrossel-fluido.js, card._fennAtualizarDados) quando
  // o Shopify reaproveitou o MESMO elemento pra outro produto (janela da cestinha aberta pra um 2º
  // produto) e ele recarregou a lista de fotos - nessa hora ele volta pra cor inicial do produto
  // novo, então a foto precisa ser alinhada de novo com o rádio de cor que está marcado.
  document.addEventListener('fenn:carrossel-dados', function (e) {
    var modal = document.getElementById('quick-add-modal-content');
    if (modal && e.target instanceof Node && modal.contains(e.target)) {
      ligarModal();
      modal.querySelectorAll('fieldset.fenn-opcao-cor').forEach(function (fs) { trocarFotoDaCor(fs, modal); });
    } else {
      ligar();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ligar(); observar(); ligarModal(); observarModal(); });
  } else {
    ligar(); observar(); ligarModal(); observarModal();
  }

  // Fenn (16/09/2026): girar o celular (ou redimensionar no desktop) muda o tamanho do hexágono
  // (34px -> 28px no breakpoint de 750px, fenn-produto.css) e por tabela a altura certa do fieldset -
  // sem remedir aqui, --fenn-cor-altura-travada ficaria travada no valor ANTIGO depois de girar,
  // cortando (ou sobrando espaço) na fileira. Debounce simples: só remede 150ms depois do último
  // evento, pra não forçar layout a cada pixel de um resize arrastado.
  var timerResize;
  window.addEventListener('resize', function () {
    clearTimeout(timerResize);
    timerResize = setTimeout(function () {
      var fieldset = document.querySelector("main[data-template='product'] fieldset.fenn-opcao-cor");
      if (fieldset) travarAltura(fieldset);
    }, 150);
  }, { passive: true });
})();
